// The ONLY way a figure reaches the screen on /live's insights panel (the phrasing rule):
// "N claims", "N vouched", "N anchored", "across N people", or, for a cell the rail masked
// because fewer than 10 people are behind it, "fewer than 10". Nothing else: no person nouns,
// no percentages of people, no singular/plural branching that could slip a noun in.
export type FigureKind = "claims" | "vouched" | "anchored" | "people";
export type Cell = number | { masked: true };

const nf = new Intl.NumberFormat("en-IN");

export function isMasked(c: unknown): c is { masked: true } {
  return !!c && typeof c === "object" && (c as any).masked === true;
}

export function figure(cell: Cell, kind: FigureKind): string {
  if (isMasked(cell)) return "fewer than 10";
  if (typeof cell !== "number" || !Number.isInteger(cell) || cell < 0) throw new Error(`not a figure: ${String(cell)}`);
  const n = nf.format(cell);
  switch (kind) {
    case "claims": return `${n} claims`;
    case "vouched": return `${n} vouched`;
    case "anchored": return `${n} anchored`;
    case "people": return `across ${n} people`;
    default: throw new Error(`not a figure kind: ${String(kind)}`);
  }
}
